// @ts-nocheck

import * as Types from '../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type DeleteNotificationMutationVariables = Types.Exact<{
  uid: Types.Scalars['String']['input'];
}>;

export type DeleteNotificationMutation = { deleteNotification: { uid: string } };

export const DeleteNotificationDocument = gql`
    mutation DeleteNotification($uid: String!) {
  deleteNotification(uid: $uid) {
    uid
  }
}
    ` as unknown as DocumentNode<DeleteNotificationMutation, DeleteNotificationMutationVariables>;
